// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "refuse-2c6mw";
var _3 = "dialog__deleteIcon-1faAp";
export { _1 as "__esModule", _2 as "refuse", _3 as "dialog__deleteIcon" }
export default { "__esModule": _1, "refuse": _2, "dialog__deleteIcon": _3 }
